/* Copyright (c) 2025 MOCA Systems, Inc.  All rights reserved. */
/**
 * The scale value of text in canvasland. These are the values set when using the Settings -> Ticket Font Size
 * configuration options, and should be used to set the UserPreferenceService.canvasTextScale.
 */
export enum TicketFontSizes {
	Small = 0.6,
	Normal = 1,
	Large = 1.25,
}
